(function () {
  'use strict';

  angular
    .module('app')
    .component('providerAssociatedBankAccounts', providerAssociatedBankAccounts());

  function providerAssociatedBankAccounts() {
    return {
      bindings: {
        provider: '=',
        associatedBanks: '=',
        onAssociatedBankSaved: '&',
        onAssociatedBankDeleted: '&',
      },
      controller: ProviderAssociatedBankAccountsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/providers/components/provider-associated-bank-accounts/provider-associated-bank-accounts.component.html',
    };
  }

  ProviderAssociatedBankAccountsComponent.$inject = [
    'UtilService',
    'BankService',
    'ProviderService',
  ];

  function ProviderAssociatedBankAccountsComponent(UtilService, BankService, ProviderService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    const fieldsDefinition = ['bank', 'account_number', 'account_holder'];

    vm.addAssociatedBank = addAssociatedBank;
    vm.saveAssociatedBank = saveAssociatedBank;
    vm.editAssociatedBank = editAssociatedBank;
    vm.removeAssociatedBank = removeAssociatedBank;
    vm.deleteAssociatedBank = deleteAssociatedBank;
    vm.validateElements = validateElements;

    vm.$onInit = function () {
      getBanks();
    };

    function getBanks() {
      vm.loadingBanks = true;

      BankService.getBanks().then(function () {
        vm.banks = BankService.items;

        vm.loadingBanks = false;
      });
    }

    function addAssociatedBank() {
      vm.addMode = true;
      vm.associatedBanks.push({});
    }

    function saveAssociatedBank(associatedBank, isFormValid) {
      associatedBank.serverErrors = [];

      if (isFormValid) {
        vm.item = {
          account_number: associatedBank.account_number,
          account_holder: associatedBank.account_holder,
          bank_name: associatedBank.bank.name,
          bank_id: associatedBank.bank.id,
          provider_id: vm.provider.id,
        };

        if (associatedBank.editMode) {
          vm.item.id = associatedBank.id;
        }

        vm.sendingForm = true;
        ProviderService.saveAssociatedBank(vm.item, vm.provider.id).then(function (data) {
          if (!data.errors) {
            // Success
            associatedBank.id = data.id;
            associatedBank.bank_name = data.bank_name;
            associatedBank.account_number = data.account_number;
            associatedBank.account_holder = data.account_holder;

            vm.onAssociatedBankSaved({ items: vm.associatedBanks });

            vm.associatedBanks = vm.associatedBanks.sort((a, b) => (a.name < b.name ? 1 : -1));

            associatedBank.editMode = false;
            delete associatedBank.originalValues;
          } else {
            associatedBank.serverErrors = vm.UtilService._showItemServerErrors(data.errors);
          }

          vm.addMode = false;
          vm.sendingForm = false;
        });
      }
    }

    function removeAssociatedBank(index) {
      vm.addMode = false;

      vm.associatedBanks.splice(index, 1);
    }

    function editAssociatedBank(associatedBank) {
      associatedBank.editMode = !associatedBank.editMode;

      if (!associatedBank.editMode) {
        _restoreOriginalValues(associatedBank);
      } else {
        associatedBank.originalValues = angular.toJson(associatedBank);
      }
    }

    function _restoreOriginalValues(associatedBank) {
      const serverItem = angular.fromJson(associatedBank.originalValues);

      fieldsDefinition.forEach(function (field) {
        associatedBank[field] = serverItem[field];
      });
    }

    function deleteAssociatedBank(associatedBank) {
      var successCallback = function () {
        var index = vm.associatedBanks.indexOf(associatedBank);

        removeAssociatedBank(index);

        vm.onAssociatedBankSaved({ items: vm.associatedBanks });
      };

      ProviderService.deleteAssociatedBank(associatedBank, vm.provider.id, successCallback);
    }

    function validateElements(associatedBank) {
      vm.hasElementsAlike = false;
      vm.elementsAlike = [];
      associatedBank.error = false;

      vm.associatedBanks.map((item, indexItem) => {
        vm.associatedBanks.forEach((element, indexElement) => {
          if (
            item.account_number === element.account_number &&
            item.bank.id === element.bank.id &&
            indexItem !== indexElement
          ) {
            vm.elementsAlike.push(indexElement);
            vm.hasElementsAlike = true;
            associatedBank.error = true;
          }
        });
      });
    }
  }
})();
